<template>
  <v-container>
    <v-layout row wrap >
      <v-flex xs2 class="text-xs-left" >
            <v-btn @click='calculateall' :disabled='inplay'>Calculate</v-btn>
        </v-flex>
        <v-flex xs8 class="text-xs-center" >
              <span class='headline'>{{tabletitle}}</span>
          </v-flex>
      <v-flex xs2  class="text-xs-right" >
          <v-btn-toggle
            v-model="showRank"
            class="transparent"
          >
            <v-btn :value="true" flat>Ranking</v-btn>
            <v-btn :value="false" flat>LE Gain</v-btn>
          </v-btn-toggle>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 class='patientpanel' :style='tableStyle'>
        <v-data-table
          :headers="headers"
          :items="resultsource"
          :pagination.sync = "pagination"
          class="elevation-1"
          v-if='serviceRankings.length>0'
          hide-actions
          :loading='inplay'
        >
          <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
          <template slot='items' slot-scope="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.stdev }}</td>
            <td class="text-xs-center" :class='{na:props.item.S01=="N/A"|props.item.S01=="+"}'><span v-if='props.item.S01!="Empty"'>{{ props.item.S01 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S02=="N/A"|props.item.S02=="+"}'><span v-if='props.item.S02!="Empty"'>{{ props.item.S02 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S03=="N/A"|props.item.S03=="+"}'><span v-if='props.item.S03!="Empty"'>{{ props.item.S03 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S04=="N/A"|props.item.S04=="+"}'><span v-if='props.item.S04!="Empty"'>{{ props.item.S04 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S05=="N/A"|props.item.S05=="+"}'><span v-if='props.item.S05!="Empty"'>{{ props.item.S05 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S06=="N/A"|props.item.S06=="+"}'><span v-if='props.item.S06!="Empty"'>{{ props.item.S06 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S07=="N/A"|props.item.S07=="+"}'><span v-if='props.item.S07!="Empty"'>{{ props.item.S07 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S08=="N/A"|props.item.S08=="+"}'><span v-if='props.item.S08!="Empty"'>{{ props.item.S08 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S09=="N/A"|props.item.S09=="+"}'><span v-if='props.item.S09!="Empty"'>{{ props.item.S09 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S10=="N/A"|props.item.S10=="+"}'><span v-if='props.item.S10!="Empty"'>{{ props.item.S10 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S11=="N/A"|props.item.S11=="+"}'><span v-if='props.item.S11!="Empty"'>{{ props.item.S11 }}</span></td>
            <td class="text-xs-center" :class='{na:props.item.S12=="N/A"|props.item.S12=="+"}'><span v-if='props.item.S12!="Empty"'>{{ props.item.S12 }}</span></td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snackbar" >
      Error! Please view app log to see more details.
      <v-btn  dark flat   @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>

// import reccard from '../components/reccard.vue'
    import ss from 'simple-statistics'
    export default {
    data: () => ({
      events: [],
      input: null,
      reclistko:{"naan":'ipp',"name":'recommendationtable',"ver":'v0.0.2','endpoint':'recommendationlist'},
      executiveko:{"naan":'ipp',"name":'executive',"ver":'v0.0.2','endpoint':'process'},
      reclistready: false,
      eventlog: [],
      patientModel: {},
      patientready:true,
      reccomputed:0,
      patientIndex:-1,
      windowHeight:0,
      rankedrecs:[],
      testResult:{},
      animatedlist:[],
      reclist:{},
      outcome:{},
      unityear:true,
      pagination: {
        sortBy: 'name',
        rowsPerPage: -1
      },
      selected: [],
      testcases:['S01','S02','S03','S04','S05','S06','S07','S08','S09','S10','S11','S12'],
      headers: [
        { text: 'Service', align: 'center', value: 'name' },
        { text: 'STDEV', align: 'center', value: 'stdev' },
        { text: 'S01', align: 'center', value: 'S01' },
        { text: 'S02', align: 'center', value: 'S02' },
        { text: 'S03', align: 'center', value: 'S03' },
        { text: 'S04', align: 'center', value: 'S04' },
        { text: 'S05', align: 'center', value: 'S05' },
        { text: 'S06', align: 'center', value: 'S06' },
        { text: 'S07', align: 'center', value: 'S07' },
        { text: 'S08', align: 'center', value: 'S08' },
        { text: 'S09', align: 'center', value: 'S09' },
        { text: 'S10',align: 'center', value: 'S10' },
        { text: 'S11', align: 'center',value: 'S11' },
        { text: 'S12',align: 'center',  value: 'S12' }
      ],
      serviceRankings: [
        {  name: 'AAA Screening',  stdev:0,reckey:"aaascreening", S01: "N/A", S02: "N/A", S03: "N/A", S04: "N/A", S05:"N/A", S06: "N/A", S07: 3, S08: 6, S09: "N/A", S10: "N/A", S11: "N/A", S12: "N/A" },
        {  name: 'Alcohol Misuse', stdev:0, reckey:"decreasealcoholuse", S01: "Empty", S02: "Empty", S03: 4, S04: "Empty", S05: "Empty", S06: 4, S07: "Empty", S08: "Empty", S09: 3, S10: "Empty", S11: "Empty", S12: 3 },
        {  name: 'Aspirin Use',stdev:0, reckey:"aspprev", S01: 3, S02: 7 , S03: 7, S04: "Empty" , S05: "Empty" , S06: 8, S07: "N/A", S08: "N/A", S09: "N/A", S10: "N/A", S11: "N/A", S12: "N/A" },
        {  name: 'BRCA-related cancer risk assessment',stdev:0, reckey:"brca12geneticscreening", S01: "N/A", S02: "N/A", S03: "N/A", S04: 1, S05: 3, S06: 9, S07: "N/A", S08: "N/A", S09: "N/A", S10: 1, S11: 4, S12: 8 },
        {  name: 'Breast Cancer Preventive Medication',stdev:0, reckey:"brcaprevmed", S01: "N/A", S02: "N/A", S03: "N/A", S04: "Empty", S05: "Empty", S06: 12, S07: "N/A", S08: "N/A", S09: "N/A", S10: "Empty", S11: 8, S12: "Empty" },
        {  name: 'Breast Cancer Screening',stdev:0,  reckey:"brcascreening", S01: "N/A", S02: "N/A", S03: "N/A", S04: 2, S05: 4, S06: 10, S07: "N/A", S08: "N/A", S09: "N/A", S10: 2, S11: "N/A", S12: "N/A" },
        {  name: 'Cervical Cancer Screening',stdev:0, reckey:"cervicalscreening", S01: "N/A", S02: "N/A", S03: "N/A", S04: 5, S05: 7, S06: 14, S07: "N/A", S08: "N/A", S09: "N/A", S10: "N/A", S11: "N/A", S12: "N/A" },
        {  name: 'CRC Screening',stdev:0, reckey:"crcscreening", S01: 2, S02: 6, S03: 11, S04: 3, S05: "Empty", S06: 13, S07: 1, S08: 7, S09: 8, S10: 3, S11: 3, S12: 10},
        {  name: 'Depression Control', stdev:0, reckey:"depressioncontrol", S01: "Empty", S02: "Empty", S03: 6, S04: "Empty", S05:"Empty", S06:6, S07: "Empty", S08: "Empty", S09: 6, S10: "Empty", S11: "Empty", S12: 6 },
        {  name: 'Diabetes Control', stdev:0, reckey:"diabetescontrol", S01: "Empty", S02: "Empty", S03: 6, S04: "Empty", S05:"Empty", S06:6, S07: "Empty", S08: "Empty", S09: 6, S10: "Empty", S11: "Empty", S12: 6 },
        {  name: 'Diabetes Screening',stdev:0,  reckey:"diabetesscreening", S01: "N/A", S02: "Empty", S03: "N/A", S04: "N/A", S05:8, S06:"N/A", S07: "N/A", S08: "N/A", S09: "N/A", S10: "N/A", S11: "N/A", S12: "N/A" },
        {  name: 'Healthful Diet & activity counseling',stdev:0, reckey:"healthydiet", S01: 1, S02: 2, S03: 3, S04: 4, S05: 2, S06: 3, S07: 2, S08: 2, S09: 4, S10: 4, S11: 2, S12: 2 },
        {  name: 'HIV screening', stdev:0,reckey:"hivtest", S01: 4, S02: 8, S03: 9, S04: 6, S05: 9, S06: 16, S07: "N/A", S08: "N/A", S09: "N/A", S10: "N/A", S11: "N/A", S12: "N/A" },
        {  name: 'Lower Blood Pressure', stdev:0, reckey:"lowerbp", S01: "Empty", S02: 5, S03: 5, S04: "Empty", S05: 6, S06: 5, S07: "Empty", S08: 4, S09:5, S10: "Empty", S11: 5, S12: 5 },
        {  name: 'Lung Cancer Screening',stdev:0, reckey:"lungcscreening", S01: "N/A", S02: 3, S03: 10, S04: "N/A", S05: 5, S06:11, S07: "N/A", S08: 3, S09: 7, S10: "N/A", S11: 6, S12: 7 },
        {  name: 'Osteoporosis risk assessment and screening',stdev:0, reckey:"osteoporosisscreening", S01: "N/A", S02: "N/A", S03: "N/A", S04: "Empty" , S05: "Empty" , S06: 15 , S07: "N/A", S08: "N/A", S09: "N/A", S10: "Empty" , S11: "Empty" , S12: 9 },
        {  name: 'Statin Use',stdev:0,  reckey:"statinuse", S01: "Empty", S02:4, S03: 8, S04: "Empty", S05: "Empty", S06: 7, S07: "Empty", S08: 5, S09: "Empty", S10: "Empty", S11: 7, S12: "N/A" },
        {  name: 'Tobacco Smoking Cessation',stdev:0, reckey:"quitsmoking", S01: "N/A", S02: "N/A", S03:2, S04: "N/A", S05: "N/A", S06: 2, S07: "N/A", S08: "N/A", S09: 2, S10: "N/A", S11: "N/A", S12: 4 },
        {  name: 'Weight Loss Intervention',stdev:0, reckey:"loseweight", S01: "N/A", S02: 1, S03: 1, S04: "N/A", S05: 1, S06: 1, S07: "N/A", S08: 1, S09:1, S10: "N/A", S11: 1, S12: 1 },
        {  name: 'Weight Lose 10 lbs',stdev:0, reckey:"lose10lb", S01: "N/A", S02: 1, S03: 1, S04: "N/A", S05: 1, S06: 1, S07: "N/A", S08: 1, S09:1, S10: "N/A", S11: 1, S12: 1 },
      ],
      serviceGains: [
        {  name: 'AAA Screening',  reckey:"aaascreening", S01: "+", S02: "+", S03: "+", S04: "+", S05:"+", S06: "+", S07: "0.00", S08: 0.02, S09: "+", S10: "+", S11: "+", S12: "+" },
        {  name: 'Alcohol Misuse',  reckey:"decreasealcoholuse", S01: "-", S02: "-", S03: 0.95, S04: "-", S05: "-", S06: 1.04, S07: "-", S08: "-", S09: 0.60, S10: "-", S11: "-", S12: 0.67 },
        {  name: 'Aspirin Use', reckey:"aspprev", S01: 0.02, S02: 0.07, S03: 0.14, S04: "-" , S05: "-" , S06: 0.16, S07: "+", S08: "+", S09: "+", S10: "+", S11: "+", S12: "+" },
        {  name: 'BRCA-related cancer risk assessment', reckey:"brca12geneticscreening", S01: "+", S02: "+", S03: "+", S04: 0.29, S05: 0.30, S06: 0.14, S07: "+", S08: "+", S09: "+", S10: 0.11, S11: 0.13, S12: 0.02 },
        {  name: 'Breast Cancer Preventive Medication', reckey:"brcaprevmed", S01: "+", S02: "+", S03: "+", S04: "-", S05: "-", S06: 0.01, S07: "+", S08: "+", S09: "+", S10: "-", S11: 0.03, S12: "-" },
        {  name: 'Breast Cancer Screening',  reckey:"brcascreening", S01: "+", S02: "+", S03: "+", S04: 0.26, S05: 0.28, S06: 0.11, S07: "+", S08: "+", S09: "+", S10: 0.11, S11: "+", S12: "+" },
        {  name: 'Cervical Cancer Screening', reckey:"cervicalscreening", S01: "+", S02: "+", S03: "+", S04: 0.04, S05: 0.01, S06: "0.00", S07: "+", S08: "+", S09: "+", S10: "+", S11: "+", S12: "+" },
        {  name: 'CRC Screening', reckey:"crcscreening", S01:0.17, S02: 0.11, S03: 0.05, S04: 0.16, S05: "-", S06: 0.01, S07: 0.09, S08: 0.02, S09: "0.00", S10: 0.07, S11: 0.18, S12: "0.00"},
        {  name: 'Depression Control', stdev:0, reckey:"depressioncontrol", S01: "+", S02: "+", S03: 6, S04: "+", S05:"+", S06:6, S07: "+", S08: "+", S09: 6, S10: "+", S11: "+", S12: 6 },
        {  name: 'Diabetes Control',  reckey:"diabetescontrol", S01: "-", S02: "-", S03: 0.31, S04: "-", S05:"-", S06:0.39, S07: "-", S08: "-", S09: 0.05, S10: "-", S11: "-", S12: 0.04},
        {  name: 'Diabetes Screening',  reckey:"diabetesscreening", S01: "+", S02: "-", S03: "+", S04: "+", S05:"0.00", S06:"+", S07: "+", S08: "+", S09: "+", S10: "+", S11: "+", S12: "+" },
        {  name: 'Healthful Diet & activity counseling', reckey:"healthydiet", S01: 0.24, S02: 1.41, S03: 1.10, S04: 0.10, S05: 1.86, S06: 1.67, S07: 0.08, S08: 1.40, S09: 0.55, S10: 0.05, S11: 0.72, S12: 0.79 },
        {  name: 'HIV screening', reckey:"hivtest", S01: "0.00", S02: 0.01, S03: 0.07, S04: "0.00", S05: "0.00", S06: "0.00", S07: "+", S08: "+", S09: "+", S10: "+", S11: "+", S12: "+" },
        {  name: 'Lower Blood Pressure',  reckey:"lowerbp", S01: "-", S02: 0.16, S03: 0.42, S04: "-", S05: 0.16, S06: 0.99, S07: "-", S08: 0.10, S09:0.18, S10: "-", S11: 0.12, S12: 0.37},
        {  name: 'Lung Cancer Screening', reckey:"lungcscreening", S01: "+", S02: 0.47, S03: 0.06, S04: "+", S05: 0.27, S06:0.06, S07: "+", S08: 0.17, S09: 0.04, S10: "+", S11: 0.09, S12: 0.03 },
        {  name: 'Osteoporosis risk assessment and screening', reckey:"osteoporosisscreening", S01: "+", S02: "+", S03: "+", S04: "-" , S05: "-" , S06: "0.00" , S07: "+", S08: "+", S09: "+", S10: "-" , S11: "-" , S12: "0.00" },
        {  name: 'Statin Use',  reckey:"statinuse", S01: "-", S02:0.18, S03: 0.13, S04: "-", S05: "-", S06: 0.18, S07: "-", S08: 0.07, S09: "-", S10: "-", S11: 0.04, S12: "+" },
        {  name: 'Tobacco Smoking Cessation', reckey:"quitsmoking", S01: "+", S02: "+", S03:2.24, S04: "+", S05: "+", S06: 1.68, S07: "+", S08: "+", S09: 0.89, S10: "+", S11: "+", S12: 0.55 },
        {  name: 'Weight Loss Intervention', reckey:"loseweight", S01: "+", S02: 2.08, S03:3.82, S04: "+", S05: 3.57, S06: 4.84, S07: "+", S08: 2.51, S09:1.70, S10: "+", S11: 0.82, S12: 2.22 },
        {  name: 'Weight Lose 10 lbs', reckey:"lose10lb", S01: "+", S02: 2.08, S03:3.82, S04: "+", S05: 3.57, S06: 4.84, S07: "+", S08: 2.51, S09:1.70, S10: "+", S11: 0.82, S12: 2.22 },
      ],
      showRank: true,
      currentService:"",
      hasError:false,
      snackbar: false,
      inplay:false
    }),
    created: function(){
      // this.$bus.$on('selectPatient', this.selectPatient )
    },
    mounted: function() {
      var self=this
      this.windowHeight = window.innerHeight
      window.addEventListener('resize', () => {
          self.windowHeight = window.innerHeight
        });
      this.patientIndex=this.$store.getters.getCurrentPatientIndex
      this.patientModel= JSON.parse(JSON.stringify(this.currentPatientData))
    },
    watch:{
      myPatient: function(){
        if(this.myPatient!=null){
          this.patientModel= JSON.parse(JSON.stringify(this.currentPatientData))
        }
      }
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      decimal2: function(value) {
        if(!value) return ''
        return value.toFixed(2)
      },
      decimal0: function(value) {
        if(!value) return ''
        return value.toFixed(0)
      }
    },
    computed: {
      tabletitle (){
        if(this.showRank){
          return "Recommended Service Rankings"
        } else {
          return "Life Expectancy Gain (Years) From the Recommended Services"
        }
      },
      resultsource () {
        if(this.showRank){
          return this.serviceRankings
        } else {
          return this.serviceGains
        }
      },
      orderedrecs: function(){
        return this.animatedlist.sort(function(a,b){return b.gain-a.gain})
      },
      comprogress: function(){
        if(this.rankedrecs.length==0){
          return 0
        } else {
          return this.reccomputed*100/this.rankedrecs.length
        }
      },
      currentPatientData () {
        return this.$store.getters.getcurrentPatientData
      },
      patientScenarios () {
        return this.$store.getters.getPatientData
      },
      panelheight: function(){
        return this.windowHeight - 250
      },
      tableheight: function(){
        return this.windowHeight - 210
      },
      panelStyle () {
        return {
          height: `${this.panelheight}px`,
        }
      },
      tableStyle () {
        return {
          height: `${this.tableheight}px`,
        }
      },
      timeline () {
        return this.events.slice().reverse()
      },
      activator_url: function(){
        return this.$store.getters.getcurrentactivatorurl
      },
      library_url: function(){
        return 'http://localhost:8081/'
        // return this.$store.getters.getlibraryurl
      },
      objlink:function(){
        return this.library_url+'/#/object/'+this.reclistko.naan+'%2F'+this.reclistko.name+'%2F'+this.reclistko.ver
      },
      myPatient: function(){
        if(this.patientIndex!=-1){
          return this.$store.getters.getPatientPanel(this.patientIndex)
        } else {
          return null
        }
      },
      myPatientDisplay: function(){
        var groupPanel = {}
        var female = (this.patientModel.patient.features.gender.toLowerCase() == 'female')
        if(this.myPatient!=null){
          this.myPatient.patient.features.forEach(function(e){
            var displayable=true
            if(groupPanel[e.group]==null){
              groupPanel[e.group]=[]
            }
            if(e.flag){
              if(e.flag=='female'){
                displayable=displayable&&female
              }
            }
            e.display=displayable
            if(displayable){
              groupPanel[e.group].push(e)
            }
          })
        }
        return groupPanel
      },
      groupSchema:function(){
          return this.$store.getters.getGroupDisplaySchema
      },
      datastr: function(){
        return "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.rankedrecs))
      },
      resultjson:function(){
        return this.patientModel.patient.id.replace('ipp-patient-','')+'.json'
      }
    },
    methods: {
      resetresults: function() {
        this.serviceRankings.forEach(function(e,index){
          for(var key in e){
            if(key!="name"&&key!='reckey'&&key!='stdev'){
              if(e[key]!='N/A'){
                e[key]='Empty'
              }
            }
          }
        })
        this.serviceGains.forEach(function(e,index){
          for(var key in e){
            if(key!="name"&&key!='reckey'){
              if(e[key]!='+'){
                e[key]='-'
              }
            }
          }
        })
      },
      updateresults: function(obj){
        var pid = Object.keys(obj)[0]
        console.log(pid)
        this.serviceRankings.forEach(function(e,index){
          for(var k in obj[pid]){
            if(e.reckey==obj[pid][k].name){
              // if(e[pid]!='N/A'){
                if(obj[pid][k].desirable){
                  e[pid]=parseInt(k)+1
                }else{
                  e[pid]='Empty'
                }
              // }
            }
          }
        })
        this.serviceGains.forEach(function(e,index){
          for(var k in obj[pid]){
            if(e.reckey==obj[pid][k].name){
              // if(e[pid]!='+'){
                if(obj[pid][k].desirable){
                  e[pid]=obj[pid][k].gain.toFixed(2)
                }
              // }
            }
          }
        })
      },
      processArray: function (array, fn) {
        var index = 0;
        return new Promise(function(resolve, reject) {
          function next() {
            if (index < array.length) {
              fn(array[index++]).then(next, reject);
            } else {
              resolve();
            }
          }
          next();
        })
      },
      KOPostaxios:function(instr){
        var self = this
        var config = {
          method:'post',
          url:this.activator_url+ instr.arkID + instr.endpoint,
          "headers": {
            "content-type": "application/json",
          },
          "data": instr.data
        }
        self.appendLog(instr.key, "K-GRID Service Request - Sending Patient Data for "+instr.key +" to Knowledge Object: " + instr.arkID);
        return this.$http(config)
          .then(function(response){
            instr.success(response.data)
            self.hasError = false;
            self.appendLog(instr.key, "K-GRID Service Response - Response results for "+instr.key +" returned from Knowledge Object: " + instr.arkID);
          })
          .catch(function(error){
            // self.appendLog(instr.key, "K-GRID Service Response - Error Message: " + error.response.status);
            console.error(error)
            self.hasError = true;
            self.snackbar =true;
            if(error.response.status==404){
              self.error404=true;
            }
            if (error.response) {
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            }
            instr.error(error.response.data);
            // self.appendLog('err', "K-GRID Service Response - Error returned from Knowledge Object: " + instr.arkID);
          })
      },
      appendLog: function (key, s) {
        var ts = this.$moment().format('ddd, MMM Do YYYY, h:mm:ss A Z')
        var text = ts+" "+s
        this.$bus.$emit('newentry', text)
      },
      calculateall: function(){
        var self=this
        this.inplay=true
        this.resetresults()
        this.processArray(this.patientScenarios, this.testfunc).then(
          ()=> {
            console.log("Done")
            self.serviceRankings.forEach(function(e,index){
              var rankingresult=[]
              self.testcases.forEach(function(te){
                if(e[te]!="N/A"&&e[te]!='Empty'){
                  rankingresult.push(e[te])
                }
              })
              console.log(rankingresult)
              if(rankingresult.length>0){
                e.stdev = ss.standardDeviation(rankingresult).toFixed(3)
              } else {
                e.stdev=0
              }

            })
            self.inplay=false
          }, (reason)=>{
            console.log(reason)
          }
        )

      },
      testfunc (data) {
        var self = this
        var obj ={}
        obj.arkID = this.executiveko.naan+'/'+this.executiveko.name
        obj.endpoint = '/'+this.executiveko.endpoint
        obj.data= JSON.stringify(data)
        obj.key=data.patient.id
        obj.success= function(response) {
          // console.log(response)
          var k = data.patient.id.replace('ipp-patient-','')
          self.testResult[k]=JSON.parse(JSON.stringify(response.result.rankedreclist))
          var o = {}
          o[k]=JSON.parse(JSON.stringify(response.result.rankedreclist))
          self.updateresults(o)
        }
        obj.error=function(resp){
          console.error(resp)
        }
        return this.KOPostaxios(obj)

      },
      // savefile: function(){
      //   this.$refs.downloadAnchorElem.click();
      // },
    }
  };
</script>
<style scoped>
.container {
  max-width: 100%;
}
.v-timeline {
  max-width: 86%;
  margin:0 auto;
  padding-top: 24px;
}
.patientpanel {
  background-color: #efefef;
  overflow-y:scroll;
}
.ipppanel{
  overflow-y:auto;
}
.featurelabel {
  font-size: 0.85rem;
  padding: 0 0.2rem ;
  bottom: 0;
  position: relative;
}
.featurevalue {
  font-size: 1.55rem;
  padding: 0 0.2rem 0 0.4rem;;
}
.v-card__title {
  padding: 6px 16px;
}
.v-list {
  padding: 4px 0;
}
.startbtn {
  position: absolute;
  bottom: 380px;
  width: 100%;
}
.v-input--selection-controls {
    margin-top: 0px;
    padding-top: 1px;
}
.v-input--selection-controls .v-input__slot {
    margin-bottom: 0px;
}
table.v-table tbody tr:nth-child(1) td,
table.v-table tbody tr:nth-child(2) td ,
table.v-table tbody tr:nth-child(3) td  {
  font-size: 1.15em;
  font-weight: 600;
}
td.na {
  background-color:#888;
  color:#888;
}
</style>
